import { render, staticRenderFns } from "./TreatmentCreateSection.vue?vue&type=template&id=bcd042ba"
import script from "./TreatmentCreateSection.vue?vue&type=script&lang=js"
export * from "./TreatmentCreateSection.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCreateSection.vue?vue&type=style&index=0&id=bcd042ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports